function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LiveEditor } from 'react-live';
import LineNumbers from '../LineNumbers/LineNumbers';
import "./LiveEditorLineNumbers.css";
var LIVE_EDITOR_STYLE = {
  fontFamily: '"Inconsolata", "Roboto Mono", monospace',
  lineHeight: 1.5,
  fontSize: '.875em',
  outline: 0,
  backgroundColor: '#292929'
};

var LiveEditorLineNumbers = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LiveEditorLineNumbers, _Component);

  function LiveEditorLineNumbers() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      height: 0
    };

    _this.setEditor = function (node) {
      if (node !== null) {
        _this.editor = node;
      }
    };

    return _this;
  }

  var _proto = LiveEditorLineNumbers.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.editor && this.state.height !== this.editor.scrollHeight) {
      this.setState({
        height: this.editor.scrollHeight
      });
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      ref: this.setEditor,
      className: "LiveEditorLineNumbers"
    }, /*#__PURE__*/React.createElement(LiveEditor, {
      className: "LiveEditor",
      onChange: this.props.onChange,
      style: LIVE_EDITOR_STYLE
    })), /*#__PURE__*/React.createElement(LineNumbers, {
      height: this.state.height
    }));
  };

  return LiveEditorLineNumbers;
}(Component);

LiveEditorLineNumbers.propTypes = {
  onChange: PropTypes.func
};
LiveEditorLineNumbers.defaultProps = {
  onChange: function onChange() {}
};
export default LiveEditorLineNumbers;
//# sourceMappingURL=LiveEditorLineNumbers.js.map